export const host = "https://3.39.251.78";
export const hostWeb="//3.39.251.78:443";      
export const api = "q64n2880dy5zlnjwle2uuw2v1js432zc1xnqroxqy21n3zh2"; //tinymce